import {createFeatureSelector, createSelector} from "@ngrx/store";
import {SelectorUtil} from "@app-web-central/web/shared/utils";
import {hubsFeatureKey, HubsState} from "./hubs.reducer";

export const getHubsState = createFeatureSelector<HubsState>(hubsFeatureKey);

export const getHubs = createSelector(getHubsState, (state) => state.data);
export const getHubsLoading = createSelector(getHubsState, SelectorUtil.isLoading);
